import {
  COMPANY_USER_SERVER_ONLY_FIELD_KEYS,
  type CompanyUserServerOnlyFieldKey,
} from '../constants/companyUserFirestoreSecurity';

const SERVER_ONLY_KEYS = new Set<string>(COMPANY_USER_SERVER_ONLY_FIELD_KEYS);

/** Client marker — not server-only; rules allow team-invite create with companyId/role. */
export const COMPANY_USER_JOINED_VIA_TEAM_INVITE_FIELD = 'joinedViaTeamInvite' as const;

export function omitCompanyUserServerOnlyFields(
  data: Record<string, unknown>
): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(data)) {
    if (!SERVER_ONLY_KEYS.has(key)) {
      out[key] = value;
    }
  }
  return out;
}

/** Owner self-registration — no server-only fields on Firestore create (A0). */
export function buildOwnerRegistrationCompanyUserPayload(
  data: Record<string, unknown>
): Record<string, unknown> {
  return omitCompanyUserServerOnlyFields(data);
}

/** Team invite — rules allow companyId/role/companyUserRole when joinedViaTeamInvite is set. */
export function buildTeamInviteCompanyUserPayload(
  data: Record<string, unknown>
): Record<string, unknown> {
  const base = omitCompanyUserServerOnlyFields(data);
  const payload: Record<string, unknown> = {
    ...base,
    [COMPANY_USER_JOINED_VIA_TEAM_INVITE_FIELD]: true,
  };
  if (data.companyId != null) payload.companyId = data.companyId;
  if (data.role != null) payload.role = data.role;
  if (data.companyUserRole != null) payload.companyUserRole = data.companyUserRole;
  return payload;
}

export function isCompanyUserServerOnlyField(key: string): key is CompanyUserServerOnlyFieldKey {
  return SERVER_ONLY_KEYS.has(key);
}
